import { render, staticRenderFns } from "./UserDatasetPermissions.vue?vue&type=template&id=5d57ee0c"
import script from "./UserDatasetPermissions.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDatasetPermissions.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports